import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "determinant-manager",
  templateUrl: "./determinant-manager.component.html",
})
export class DeterminantManagerComponent implements OnInit {

  @Input() public serviceId: string;
  @Input() public jsonString: string;
  @Input() public selectedDeterminant: any;
  @Input() public showBuilder: boolean = false;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Input() public showEdit: boolean = false;
  @Input() public embedded: boolean = true;

  @Output() public save = new EventEmitter();
  @Output() public cancel = new EventEmitter();
  @Output() public updateHeader = new EventEmitter();
  @Output() public builderUpdated = new EventEmitter();

  constructor(private route: ActivatedRoute) { }

  public ngOnInit(): void {
    if (!this.serviceId) {
      this.route.params.subscribe((params) => {
        this.serviceId = params.serviceId;
        console.log(this.serviceId);
      });
    }
  }

  public openEdit() {
    this.showEdit = true;
    this.selectedDeterminant = null;
    this.updateHeader.emit(false);
  }

  public builderChanged(event) {
   console.log("builderChanged", event);
    this.builderUpdated.emit(event);
  }

  public openEditDet(det) {
    this.selectedDeterminant = det;
    this.showEdit = true;
    this.updateHeader.emit(false);
  }

  public closeEdit(e) {
    console.log(e);
    this.showEdit = false;
    this.updateHeader.emit(true);
  }

  public update(e) {
    console.log(e);
    this.save.emit(e);
  }

  public onCancel() {
    this.cancel.emit();
  }

}
